import React from "react";
import {MIXED_CATEGORIES_LABEL, UNCATEGORIZED_LABEL, UNCATEGORIZED_VALUE} from "../../constants";
import {Chip, Stack, Tooltip} from "@mui/material";
import ChevronIcon from "~/icons/svg/ChevronIcon.svg?react";

import type {TaxonomyCategory} from "../../stores/TaxonomyCategoryProvider";
import {
    categoryChipArrowStyle,
    getCategoryChipSx,
} from "./categoryChip.utils";

type Props = {
    category: string[] | false | 'UNCATEGORIZED' | 'MIXED_CATEGORIES' | TaxonomyCategory
    showCategoryId?: boolean,
    showInAutocomplete?: boolean,
}
export const CategorizationViewOnlyComponent: React.FC<Props> = ({category, showCategoryId, showInAutocomplete= false}) => {
    const isArray = Array.isArray(category);
    if (category === false || (isArray && (category as string[]).every(c => c === UNCATEGORIZED_VALUE) || category === 'UNCATEGORIZED')) {
        return <>{UNCATEGORIZED_LABEL}</>;
    }
    if (category === 'MIXED_CATEGORIES') {
        return <>{MIXED_CATEGORIES_LABEL}</>;
    }

    let cats: string[];
    let customerCategoryId: string;
    if (isArray) {
        cats = (category as string[]);
        customerCategoryId = '';
    } else {
        const c: TaxonomyCategory = (category as TaxonomyCategory);
        cats = c.data.labels;
        customerCategoryId = c.data.category_id || '';
    }

    return <>
        {showCategoryId && customerCategoryId && <>
            <span className="part-cat-component-category-id">{customerCategoryId}</span>
        </>}
        <Stack
            direction="row"
            alignItems="center"
            flexWrap="nowrap"
            width={showInAutocomplete ? window.innerWidth - 50 : '100%'}
            minWidth={0}
            overflow="hidden"
            gap="4px"
        >
            {cats.map((c, i) => {
                const categoryLabel = c === UNCATEGORIZED_VALUE ? UNCATEGORIZED_LABEL : c;

                return <React.Fragment key={i}>
                    <Tooltip arrow title={categoryLabel} enterTouchDelay={0} leaveTouchDelay={3000}>
                        <Chip
                            variant="outlined"
                            size="small"
                            label={categoryLabel}
                            sx={{
                                ...getCategoryChipSx(),
                                minWidth: 0,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                            }}
                        />
                    </Tooltip>
                    {(i < cats.length - 1) && <ChevronIcon style={categoryChipArrowStyle}/>}
                </React.Fragment>;
            })}
        </Stack>
    </>
};
